export enum DynamicTitleType {
  'EXTMETADATA' = 'EXTMETADATA',
  'ACTIVITY' = 'ACTIVITY',
}
